import {connect} from 'react-redux';

import {TeammateModel} from '../../../../../../../libs/shared/core/src/models/api/teammateModel';
import {CellsContext} from '../../../../../../../libs/shared/core/src/store/panels/cells/context/cellsContext';
import {AsyncData} from '../../../../../../../libs/shared/ui/src/components/loaders/asyncDataHelpers';
import {createSelector, makeMapStateToProps} from '../../../../../../../srcCommon/helpers/reselectHelpers';
import {VisualConversationTrackerModel} from '../../../../../../../srcCommon/inboxes/viewer/conversation/participants/inviteParticipantsHelpers';
import {ConversationModel} from '../../../../../../models/api/conversationModel';
import {SeenByModel} from '../../../../../../models/api/seenByModel';
import {AppState} from '../../../../../../store/appState';
import {getFindTeammate} from '../../../../../../store/data/teammates/teammatesSelectors';
import {computeSortedSubscribersInfo} from '../../../../../../store/stateless/inviteParticipantsSelectors';
import {InviteDropdownTrackersContent} from './inviteDropdownTrackersContent';

/*
 * Props.
 */

interface InviteDropdownTrackersContainerProps {
  visualTrackers: ReadonlyArray<VisualConversationTrackerModel>;
  conversation: ConversationModel;
  conversationInboxesTeammateIds: ReadonlyArray<TeammateModel['id']>;
  cellsContext: CellsContext;
  seenBy: AsyncData<ReadonlyArray<SeenByModel>>;
  userId: number;
}

/*
 * Selectors.
 */

function getConversationInboxesTeammateIds(_state: AppState, props: InviteDropdownTrackersContainerProps) {
  return props.conversationInboxesTeammateIds;
}

function getConversation(_state: AppState, props: InviteDropdownTrackersContainerProps) {
  return props.conversation;
}

function getVisualTrackers(_state: AppState, props: InviteDropdownTrackersContainerProps) {
  return props.visualTrackers;
}

function getCellsContext(_state: AppState, props: InviteDropdownTrackersContainerProps) {
  return props.cellsContext;
}

function getUserOrDelegatedTeammateId(_state: unknown, props: {cellsContext: CellsContext}) {
  return props.cellsContext.teammateId;
}

function getSeenBy(_state: AppState, props: InviteDropdownTrackersContainerProps) {
  return props.seenBy;
}

function getUserId(_state: AppState, props: InviteDropdownTrackersContainerProps) {
  return props.userId;
}

function makeGetSortedSubscribersInfo() {
  return createSelector(
    [
      getVisualTrackers,
      getConversation,
      getConversationInboxesTeammateIds,
      getSeenBy,
      getUserId,
      getFindTeammate,
      getUserOrDelegatedTeammateId,
    ],
    (
      visualTrackers,
      conversation,
      conversationInboxesTeammateIds,
      seenBy,
      userId,
      findTeammate,
      userOrDelegatedTeammateId,
    ) =>
      computeSortedSubscribersInfo({
        visualTrackers,
        conversation,
        conversationInboxesTeammateIds,
        seenBy,
        userId,
        findTeammate,
        userOrDelegatedTeammateId,
      }),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<InviteDropdownTrackersContainerProps>()(() => ({
  sortedSubscribersInfo: makeGetSortedSubscribersInfo(),
  cellsContext: getCellsContext,
}));

export const InviteDropdownTrackersContentContainer = connect(mapStateToProps)(InviteDropdownTrackersContent);
